export const calendarMonth_November = "nJ3WWb";
export default {calendarMonth_November};